import { type IGetOrderResponse } from '@mahawi/eshop-common/src/types';
import { Space, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import { EDateFormat } from '../../fragments/date-format';
import { getTagByRelativeDate } from '../../fragments/get-tag-by-relative-date';
import { SPACING } from '../../theme/tokens';

const { Text } = Typography;

export const DateInfo = React.memo(function DateInfo({
  order,
}: {
  order: IGetOrderResponse;
}): React.ReactElement {
  return (
    <Space orientation="vertical">
      <Space size={SPACING.xs} align="baseline">
        <Text>created at:</Text>
        <Text strong>
          {dayjs(order.createdAt).format(EDateFormat.DATE_TIME)}
        </Text>
        {getTagByRelativeDate({ date: order.createdAt })}
      </Space>

      <Space size={SPACING.xs} align="baseline">
        <Text>updated at:</Text>
        <Text strong>
          {dayjs(order.updatedAt).format(EDateFormat.DATE_TIME)}
        </Text>
        {getTagByRelativeDate({ date: order.updatedAt })}
      </Space>
    </Space>
  );
});
